.drawer {
  inset: auto 0 0;
  max-height: 90vh;
}

@media (min-width: 768px) {
  .drawer {
    inset: 0 0 0 auto;
    width: 400px;
    max-height: none;
  }
}

.content {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem;
}

.action {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.close {
  flex: none;
  padding: 0;
  border: none;
  background: none;
  line-height: 1;
  cursor: pointer;
}

.requestor {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.info {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}

.user {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 200px;
}

.divider {
  height: 1px;
  background-color: #e0e0e0;
}

.inputWrapper {
  position: relative;
  padding-top: 1.25rem;
}

.charCount {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 14px;
  color: #6f6f6f;
}

.drawerFooter {
  display: flex;
  justify-content: flex-end;
}

.button {
  width: 180px;
}

.history {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.entry {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding-top: 0.75rem;
  border-top: 1px solid #e0e0e0;
}

.entryText {
  overflow-wrap: anywhere;
}
